/* eslint-disable */
import React from "react";

import clsx from "clsx";

import IReviewPage from "./ReviewPage";
import { getSignedStatus, sendA2Form } from "../../../../services/reviewPage";
import Modal from "../../../../components/ui/Modal";
import { MailIcon, MobileIcon, SuccessIcon } from "../../../../assets/Icons";
import ErrorField from "../../../../components/ui/ErrorField";
import Button from "../../../../components/ui/Button";

export const EsignModalOffline: React.FC<IReviewPage.EsignModalProps> = ({
  isEsignModal,
  setIsEsignModal,
  modalTitle,
  handleDoLaterA2Form,
  handleA2Form,
  handleLinkSent,
}) => {
  const [mobileActive, setMobileActive] = React.useState<boolean>(false);
  const [mailActive, setMailActive] = React.useState<boolean>(false);
  const [step, setStep] = React.useState<string>("1");
  const [error, setError] = React.useState<string>("");
  const [linkSent, setLinkSent] = React.useState<boolean>(false);
  const [isDisabled, setIsDisabled] = React.useState({
    mobileLoader: false,
    emailLoader: false,
  });

  React.useEffect(() => {
    let interval: any;
    if (isEsignModal) {
      interval = setInterval(() => {
        handleEsignedStatus();
      }, 3000);
    }
    return () => clearInterval(interval);
  }, [isEsignModal, step]);

  const handleEsignedStatus = () => {
    const vendorUserKey = JSON.parse(localStorage.getItem("offlineRemitter") || "{}");
    if (isEsignModal) {
      if (step === "2") {
        getSignedStatus({
          userId: vendorUserKey.user_key,
        })
          .then((response) => {
            setError("");
            if (response?.data?.signed) {
              if (step === "2") {
                setStep("3");
              }
            }
          })
          .catch((error) => {
            setError(error?.response?.data?.error?.type);
          });
      }
    }
  };

  const handleMobileNumber = () => {
    setMobileActive(true);
    setMailActive(false);
    setIsDisabled((prev) => ({ ...prev, mobileLoader: true }));
    const vendorUserKey = JSON.parse(localStorage.getItem("offlineRemitter") || "{}");
    sendA2Form({
      sendType: "sms",
      userId: vendorUserKey.user_key,
      transactionNumber: null,
      resend: false,
    })
      .then(() => {
        setStep("2");
        setError("");
        setLinkSent(true);
      })
      .catch((error) => {
        setError(error?.response?.data?.error?.type);
        setTimeout(() => {
          setError("");
        }, 3000);
      })
      .finally(() => setIsDisabled((prev) => ({ ...prev, mobileLoader: false })));
  };

  const handleMail = () => {
    setMobileActive(false);
    setIsDisabled((prev) => ({ ...prev, emailLoader: true }));
    setMailActive(true);
    const vendorUserKey = JSON.parse(localStorage.getItem("offlineRemitter") || "{}");
    sendA2Form({
      sendType: "Mail",
      userId: vendorUserKey.user_key,
      transactionNumber: null,
      resend: false,
    })
      .then((response) => {
        setStep("2");
        setError("");
        setLinkSent(true);
      })
      .catch((error) => {
        setError(error?.response?.data?.error?.type);
        setTimeout(() => {
          setError("");
        }, 3000);
      })
      .finally(() => setIsDisabled((prev) => ({ ...prev, emailLoader: false })));
  };

  return (
    <Modal
      modalClass="!p-0 md:pr-11 flex p-0 flex-col !rounded lg:!w-6/12 !w-full"
      headerClass="!mt-0 items-center text-white sticky h-24 pr-4 pl-[42%] bg-primary font-bold text-2xl"
      visible={isEsignModal}
      header={modalTitle ? modalTitle : "Sign A2 Form"}
      closeHandler={() => {
        if (linkSent) {
          handleLinkSent && handleLinkSent();
        }
        setIsEsignModal(false), setMobileActive(false), setMailActive(false);
      }}
    >
      {step === "1" && (
        <div>
          <div className="flex flex-col items-center my-8">
            <h1 className="font-semibold text-[20px]">Receive link on</h1>
            <div className="flex mt-10">
              <div className="w-64 h-auto p-5">
                <Button
                  isLoading={isDisabled.mobileLoader}
                  onClickHandler={() => handleMobileNumber()}
                  className={clsx(
                    "flex justify-between items-center rounded-lg p-5",
                    mobileActive ? "bg-primary-300 text-white" : "bg-primary-800"
                  )}
                >
                  <MobileIcon />
                  <h1 className="ml-3 text-[20px]">Mobile Number</h1>
                </Button>
              </div>
              <div className="w-64 h-auto p-5">
                <Button
                  isLoading={isDisabled.emailLoader}
                  onClickHandler={() => handleMail()}
                  className={clsx(
                    "flex justify-between items-center rounded-lg p-5",
                    mailActive ? "bg-primary-300 text-white" : "bg-primary-800"
                  )}
                >
                  <MailIcon />
                  <h1 className="text-[20px]">Mail</h1>
                </Button>
              </div>
            </div>
            <div
              onClick={handleDoLaterA2Form}
              className="mt-10 flex flex-col items-center cursor-pointer"
            >
              <h1 className="text-primary font-semibold text-[20px]">Do it later</h1>
              <ErrorField errorMessage={error} />
            </div>
          </div>
        </div>
      )}
      {step === "2" && (
        <div className="flex flex-col items-center py-10">
          <div className="w-2/5 mb-10">
            {mobileActive ? (
              <h1 className="text-center text-[15px] lg:text-[20px] text-primary font-semibold">
                A link has been sent to your registered mobile number. Please draw your signature
                and submit the same
              </h1>
            ) : (
              <h1 className="text-center text-[15px] lg:text-[20px] text-primary font-semibold">
                A link has been sent to your registered email Id. Please draw your signature and
                submit the same
              </h1>
            )}
          </div>
          <div className="mb-10">
            <h1 className="text-[15px] lg:text-[20px] font-semibold">
              Note- Please draw your signature as on your PAN card
            </h1>
          </div>
          <div className="mb-5">
            <h1 className="text-[15px] lg:text-[20px] font-semibold">Awaiting your signature.</h1>
          </div>
          <div className="flex space-x-2 animate-pulse mb-10">
            <div className="w-3 h-3 bg-gray-500 rounded-full"></div>
            <div className="w-3 h-3 bg-gray-500 rounded-full"></div>
            <div className="w-3 h-3 bg-gray-500 rounded-full"></div>
          </div>
          <Button
            isLoading={mobileActive ? isDisabled?.mobileLoader : isDisabled?.emailLoader}
            onClickHandler={mobileActive ? handleMobileNumber : handleMail}
            className="border border-primary text-white font-semibold py-2 px-4 rounded-full text-[15px] lg:text-[20px]"
          >
            Resend link
          </Button>
        </div>
      )}

      {step === "3" && (
        <div className="flex flex-col items-center py-10">
          <div className="mb-7">
            <h1 className="text-[20px] lg:text-[25px] font-bold">Your form has been signed</h1>
          </div>
          <div className="mb-8">
            <h1 className="text-[15px] lg:text-[20px] font-semibold">Thanks for completion!</h1>
          </div>
          <div className="mb-5">
            <SuccessIcon />
          </div>
          {/* <div className="mb-5">
            <h1
              onClick={(e) => handleA2Form && handleA2Form(e)}
              className="cursor-pointer text-[15px] lg:text-[20px] text-primary font-bold"
            >
              Download A2
            </h1>
          </div> */}
          <div>
            <h1
              onClick={() => {
                setIsEsignModal(false, setStep("1"));
              }}
              className="cursor-pointer text-[15px] lg:text-[20px] text-primary font-bold"
            >
              Go Back
            </h1>
          </div>
        </div>
      )}
    </Modal>
  );
};

export default EsignModalOffline;
